<app-link link="/adventure-trips">
    <span class="text-white/80">Trips</span>
</app-link>
<span class="p-2 font-black text-red">/</span>
<app-link [link]="'/adventure-trips/' + itinerary?.trip?.urlSlug">
    <span class="text-white/80">{{ itinerary?.trip?.title }}</span>
</app-link>
<app-json-ld [json]="seoBreadCrumbs"></app-json-ld>
